import { config } from '../config';
import { getAuthToken } from '../auth/session';
export async function gql(query, variables = {}, opts = {}) {
    // AppSync quirk: anonymous calls must send Authorization: "null" (string),
    // not omit the header. Matches dealroom-fe's apollo-link.ts behaviour.
    const headers = {
        'Content-Type': 'application/json',
        Authorization: opts.anonymous ? 'null' : await getAuthToken(),
    };
    const res = await fetch(config.gqlEndpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify({ query, variables }),
    });
    const json = await res.json();
    if (json.errors?.length) {
        throw new Error(json.errors.map((e) => e.message).join('; '));
    }
    return json.data;
}
